module.exports = __webpack_public_path__ + "img/netfest_logo_favicon-removebg-preview.b6334dae.png";